import { ArrowDownward } from '@mui/icons-material';
import {
  ServiceLogo,
  type ServiceType,
} from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import {
  type ColumnOption,
  getColumnHeaderList,
  SortFilter,
} from '@public/components/Db/Filters/SortFilter';
import { createKey } from '@public/utils/meta';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

import styles from './IndustryComparisonTpHeaders.module.scss';

interface ITeamRosterListHeaderProps {
  selected: ColumnOption;
  columns: ColumnOption[];
  onChange?: (column: ColumnOption) => void;
  ascending: boolean;
  disabled?: boolean;
  rankingYear?: number | null;
}
export const IndustryComparisonTpHeaders = ({
  selected,
  onChange,
  ascending,
  disabled,
  columns,
  rankingYear,
}: ITeamRosterListHeaderProps) => {
  const router = useRouter();
  const { year = rankingYear, transferType } = router.query;
  const isRivalsIndustry = year && +year > 2024;

  const filteredColumns = useMemo(() => {
    if (isRivalsIndustry) {
      return columns.filter((c) => c !== 'Rivals');
    }

    return columns;
  }, [columns, isRivalsIndustry]) as ColumnOption[];

  const handleSort = (e: React.MouseEvent<HTMLButtonElement>) => {
    const sortType = e.currentTarget.dataset.sorttype as ColumnOption;

    if (onChange) {
      onChange(sortType);
    }
  };

  const headerListSelection = getColumnHeaderList(filteredColumns);

  return (
    <div className={styles.wrapper}>
      <div className={styles.mobileSort}>
        <SortFilter
          ascending={ascending}
          handleSort={handleSort}
          key={createKey(selected, ascending ? 'asc' : 'desc')}
          selected={selected}
          sortList={headerListSelection}
        />
      </div>
      <header>
        <div
          className={styles.block}
          data-list-type={transferType}
          data-rivals-industry={isRivalsIndustry}
        >
          {headerListSelection.map((item) => {
            const isSelected = item.name === selected;
            const logoType =
              item.name === 'Industry' ? 'on3industry' : item.name;

            return (
              <div
                aria-sort={
                  isSelected ? (ascending ? 'ascending' : 'descending') : 'none'
                }
                className={styles.headerItem}
                id={item.ariaLabel}
                key={item.key}
                role="columnheader"
              >
                <button
                  aria-controls="player-list"
                  data-active={selected === item.name}
                  data-flip={item.flipDirection}
                  data-sorttype={item.name}
                  disabled={disabled}
                  onClick={
                    onChange
                      ? () => onChange(item.name as ColumnOption)
                      : undefined
                  }
                >
                  {item.isLogo ? (
                    <ServiceLogo type={logoType as ServiceType} />
                  ) : (
                    <span>{item.displayName}</span>
                  )}
                  {isSelected && <ArrowDownward className={styles.arrow} />}
                </button>
              </div>
            );
          })}
        </div>
      </header>
    </div>
  );
};
